export default "__VITE_ASSET__8C0EGTBH__"